export default (context, address) => {
  context.setState({
    address: address,
    error: null
  });
};



// WEBPACK FOOTER //
// ./src/handlers/setCurrentAddress.js